import axios from "axios";

export default {
  namespaced: true,
  state: {
    planillas: null,
    jugadores: null
  },
  mutations: {
    setPlanillas(state, data) {
      state.planillas = data;
    },
    setJugadores(state, data) {
      state.jugadores = data;
    }
  },
  actions: {
    async fetchPlanillas({ state, commit }) {
      if (state.planillas) return state.planillas;
      const response = await axios.get("/api/player_tournaments");
      commit("setPlanillas", response.data);
      return response.data;
    },
    async fetchJugadores({ state, commit }) {
      if (state.jugadores) return state.jugadores;
      const response = await axios.get("/api/players");
      commit("setJugadores", response.data);
      return response.data;
    }
  }
}